<template>
  <div class='relative z-2 bg-cream-deep pa-50 mb-pa-30 mb-pr-0 br-14 nmb-100 justify-between flex mb-db overflow-hidden'>
    <div class='mb-wp-100 mb-pr-30 w-325 mb-wp-100 mr-50 mb-mr-0'>
      <h2 class='fs-36 mb-fs-28 fw-900 mb-30'>
        Our Local Designers
      </h2>
      <p class='fs-16 lh-24 mb-30 maxw-870 dib'>
        Our Local Designers are trusted partners who design, build and deliver extraordinary experiences just for you. Experts in their destinations, our Local Designers have access to unique travel experiences that you won't find anywhere else.
      </p>

    </div>
    <div class='wrapper-slide'>
      <transition>
        <Carousel
          :wrap-around="true"
          :itemsToShow= itemsToShow
          class='inner-wrapper'>
          <template #counter>
          </template>
          <Slide
            class='carousel__item'
            v-for="(item,index) in listLD" :key="index"
          >
            <div class=" relative">
              <div class='absolute top-0 left-0 wp-100 hp-100 br-16' style="background: linear-gradient(0.16deg, rgba(0, 0, 0, 0.8) 0.08%, rgba(0, 0, 0, 0) 49.94%);"></div>
              <img  class='img-cover overflow-hidden br-16 db' :src="`${$assetsCdn}/images/aboutus/${item.img}`"  alt='avatar'>
              <div class='tl absolute pa-20 wp-100 bottom-0 left-0'>
                <h3 class='white fs-28 mb-8 lh-28 fw-900'>{{item.author}}</h3>
                <p class='white fs-16 lh-16 mb-0'>{{item.country}}</p>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation>
              <template #prev>
                <div class="hand"><img alt='prev' class="nav-arrow" :src="`${$assetsCdn}/icons/icon-arrow-left-large.svg`"  /></div>
              </template>
              <template #next>
                <div class="hand"><img alt='next' class="nav-arrow" :src="`${$assetsCdn}/icons/icon-arrow-right-large.svg`"  /></div>
              </template>
            </Navigation>
          </template>
        </Carousel>
      </transition>

    </div>

  </div>
</template>
<script>
import { computed } from 'vue'
import Slide from '~/components/ui/carousel/Slide'
import Carousel from '~/components/ui/carousel/Carousel'
import Navigation from '~/components/ui/carousel/Navigation'
import { DESKTOP, PHONE, TABLET } from '~/constant/common'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

export default {
  components: {
    Slide,
    Carousel,
    Navigation
  },
  setup() {

    const generalStore = useGeneralInfoStore()
    
    const windowWidth = computed(() => generalStore.generalData.windowWidth);

    const itemsToShow = computed(() => {
      if(
        windowWidth.value < DESKTOP && windowWidth.value >= TABLET) {
        return 2.5
      }
      if(windowWidth.value < TABLET && windowWidth.value >= 900) {
        return 2
      }
      if(windowWidth.value < 900 && windowWidth.value >= PHONE) {
        return 1.2
      }
      if(windowWidth.value < PHONE && windowWidth.value >= 650) {
        return 2.5
      }
      if(windowWidth.value < 650 && windowWidth.value >= 500) {
        return 2
      }
      if(windowWidth.value < 500) {
        return 1.5
      }
      return 3
    });

    const listLD = [
      {img: 'quynh.jpg', author: 'Quynh D.', country:'Thailand and Singapore' },
      {img: 'moreno.jpg', author: 'Moreno M.', country:'Italy' },
      {img: 'michael.jpg', author: 'Michael L.', country:'Australia and Pacific' },
      {img: 'amandine.jpg', author: 'Amandine N.', country:'Japan' },
    ];


    return {listLD, windowWidth,PHONE,TABLET,DESKTOP,itemsToShow}
  }
}
</script>
<style scoped lang="scss">
// Carousel prev/next arrows → brand green (guideline pagination nav is #197660).
// <img> from a hardcoded external URL, so recolor via CSS filter (Technique B).
.nav-arrow {
  // solved black → $brand-green #197660 (achieved rgb(25,118,96), loss 0.037)
  filter: brightness(0) saturate(100%) invert(81%) sepia(44%) saturate(3721%) hue-rotate(111deg) brightness(47%) contrast(80%);
}
.carousel__item {
  padding: 0 15px;
  display: block;
}
.carousel__slide {
  opacity: 1;
}
.inner-wrapper {
  margin-left: -15px;
  margin-right: -15px;
  min-height: 280px;
  height: 100%;
  @include phone {
    padding-top: 83px;
    margin-left: 0;
  }
}
.wrapper-slide {
  width: calc(100% - 380px);
  @include phone {
    width: 100%;
  }
  :deep(.carousel) {
    .carousel__prev {
      position: absolute;
      left: -366px;
      top: auto ;
      bottom: 0;
      transform: none;
      @include phone {
        top: 0;
        bottom: auto;
        left: 0;
      }
    }
    .carousel__next {
      position: absolute;
      left: -313px;
      top: auto;
      bottom: 0;
      transform: none;
      right: auto;
      @include phone {
        top: 0;
        bottom: auto;;
        left: 53px;
      }
    }
  }
}
</style>
<style lang='scss'>

</style>
